<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">Innstillinger - {{name}}</h4>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormSubmittable">
        <a href="javascript:;" @click="onCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" @click="handleSubmit()" class="button primary">Lagre endringer</a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormProcessing">
        <a href="javascript:;" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary loading">Lagrer...<span class="loader-spinner"></span></a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormLoading">
        <a href="javascript:;" @click="onCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary" disabled>Lagre<span class="show-for-medium"> endringer</span></a>
      </div>
    </div>

    <TheLoader :active="$store.getters.isFormLoading"/>
    <div v-if="!$store.getters.isFormLoading" class="content-container flex-row">
      <section class="content large-padding fixed-width small scrollnav">
        <form @submit.prevent="handleSubmit">
          <fieldset>
            <div class="grid-x grid-padding-x">
              <TheTextInput containerClassName="cell large-6" label="Fraktgruppeid" v-model.trim="item.Fraktgruppeid" :disabled="true"/>
              <TheTextInput containerClassName="cell large-6" label="Kode" name="Kode" :disabled="edit" v-model.trim="item.Kode" maxlength="10" required v-validate="'required|max:10'"/>
              <TheTextInput containerClassName="cell large-12" label="Beskrivelse" name="Beskrivelse" v-model.trim="item.Beskrivelse" maxlength="100" v-validate="'max:100'"/>
              <TheSwitchInput containerClassName="cell large-6" label="Passiv" v-model="item.Passiv" labelTrue="Passiv" labelFalse="Ikke passiv" trueValue="T" falseValue="F"/>
              <TheSelectInput containerClassName="cell large-6" label="Vareid" name="Vareid" v-model.trim="item.Vareid" :items="vareOptions"/>
              <TheSelectInput containerClassName="cell large-6" label="Freight Type" name="FreightType" v-model.trim="item.freighttype" :items="freighttypeOptions"/>
              <div class="cell large-6" style="padding-top: 25px;">
                <a href="javascript:;" @click="addObject()">
                  <svg width="16px" height="16px" viewBox="0 0 16 16">
                    <use xlink:href="/static/sprites.svg#button-glyph-add"></use>
                  </svg>
                </a>
              </div>
            </div>
          </fieldset>
          <table>
            <tbody>
            <tr class="list-group-item" v-for="(object, index) in item.Freighttype" :key="index">
              <td style="padding: 5px;">{{object.FreighttypeName}}</td>
              <td style="padding: 5px;">
                <TheDecimalInput containerClassName="cell small-12" label="Price" :name="'Price'+index" v-model.trim="object.Price" maxlength="10" required v-validate="'max:10|decimal'" v-on:blur="refresh(object)"/>
              </td>
              <td style="padding: 5px;">
                <TheTextInput containerClassName="cell large-12" label="Zip Code" :name="'ZipCode'+index" v-model.trim="object.ZipCode" maxlength="255" required v-validate="'max:255'" v-on:blur="refresh(object)"/>
              </td>
              <td style="padding: 5px;">
                <a href="javascript:;" @click="removeObject(object)">
                  <svg width="16px" height="16px" viewBox="0 0 16 16">
                    <use xlink:href="/static/sprites.svg#button-glyph-delete"></use>
                  </svg>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import InstillingerService from '@/services/InstillingerService'

export default {
  name: 'InstillingerFraktgruppeEdit',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    name: {
      type: String,
      required: true
    },
    servicename: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      service: InstillingerService(this.servicename),
      edit: false,
      item: {
        Freighttype: []
      },
      vareOptions: [],
      freighttypeOptions: [],
      loading: true,
      error: false
    }
  },
  created () {
    // Set form to loading
    this.setFormLoading(true)

    // Edit mode
    this.edit = !!this.$route.params.id

    // Load
    this.fetch()
  },
  methods: {
    fetch: function () {
      this.vareOptions.unshift({key: this.item.Vareid, val: 'Laster...'})

      InstillingerService('freighttype').dropdown()
        .then((response) => {
          this.freighttypeOptions = response.data.map(({ key, val }) => ({ key: key, val: val }))
          this.freighttypeOptions.unshift({key: null, val: 'Velg freight type'})
        })

      InstillingerService('vare').dropdown()
        .then((response) => {
          this.vareOptions = response.data
          this.vareOptions.unshift({key: null, val: 'Velg vare'})

          if (!this.edit) {
            this.item.Passiv = 'F'

            this.setFormLoading(false)
          } else {
            this.service.view(this.$route.params.id)
              .then((response) => {
                for (let i = 0; i < response.data.freighttype.length; i++) {
                  this.item.Freighttype[i] = response.data.freighttype[i]._joinData
                  this.item.Freighttype[i].FreighttypeName = this.getFreighttypeName(response.data.freighttype[i]._joinData.FreighttypeId)
                  this.item.Freighttype[i].key = (i + 1)
                }
                this.item.Beskrivelse = response.data.Beskrivelse
                this.item.Fraktgruppeid = response.data.Fraktgruppeid
                this.item.Kode = response.data.Kode
                this.item.Passiv = response.data.Passiv
                this.item.Vareid = response.data.Vareid
                this.item.freighttype = ''
              })
              .catch(() => {
                this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn bokforgruppe')

                this.onCancel()
              })
              .then(() => {
                this.setFormLoading(false)
              })
          }
        })
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      if (this.error) {
        this.$helpers.showErrorAlert('Feil', 'Du har samme postnummer for frakttype', false, 5000)
        return
      }

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            // Force code to be uppercase
            this.item.Kode = this._.toUpper(this.item.Kode)

            this.service.save(this.item.Fraktgruppeid, this.item)
              .then((response) => {
                this.$helpers.showSuccessAlert('Bokforgruppe er lagret')
                this.$router.go(-1)
              })
              .catch((error) => {
                // Put API errors into the error container
                this.$helpers.sendApiErrorsToValidator(error, this.errors)

                // Check if new errors appeared
                if (this.errors.any()) {
                  this.errors.items.forEach((error) => {
                    this.$helpers.showErrorAlert('Feil', error.field + ', ' + error.msg, false, 5000)
                  })
                  this.$validator.resume()
                }
              })
              .then(() => {
                this.setFormProcessing(false)
              })
          }
        })
    },
    onCancel: function () {
      this.$router.go(-1)
    },
    addObject: function () {
      if (this.item.freighttype > 0) {
        this.item.Freighttype.push({
          key: this.item.Freighttype.length + 1,
          Price: '',
          ZipCode: '',
          FreighttypeId: this.item.freighttype,
          FreighttypeName: this.getFreighttypeName(null)
        })
      }
    },
    removeObject: function (object) {
      this.item.Freighttype = this.item.Freighttype.filter(function (obj) {
        return parseInt(obj.key) !== parseInt(object.key)
      })
    },
    getFreighttypeName: function (id) {
      let key = id
      if (id == null) {
        key = this.item.freighttype
      }
      let name = this.freighttypeOptions.filter(function (obj) {
        return parseInt(obj.key) === parseInt(key)
      })
      return name[0].val
    },
    refresh: function (object = null) {
      this.$forceUpdate()
      if (object !== null) {
        this.verifyFreighType(object.FreighttypeId, object.ZipCode, object.key)
      }
    },
    verifyFreighType: function (FreighttypeId, ZipCode, key) {
      this.error = false
      for (let i = 0; i < this.item.Freighttype.length; i++) {
        if (parseInt(this.item.Freighttype[i].FreighttypeId) === parseInt(FreighttypeId) &&
            this.item.Freighttype[i].ZipCode === ZipCode &&
            this.item.Freighttype[i].ZipCode !== '' &&
            this.item.Freighttype[i].key !== key) {
          this.error = true
        }
      }
      if (this.error) {
        this.$helpers.showErrorAlert('Feil', 'Du har allerede registrert dette postnummeret for denne frakttypen', true, 5000)
      }
    }
  }
}
</script>

<style>
input[name="Kode"] {
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Instillinger/InstillingerFraktgruppeEdit.vue